// 分类缓存
import { QueryClassifyTree } from '@/api'

export const loadClassifyTree = async () => {
  const result = await QueryClassifyTree({ isCleanCach: false })
  save(result)
  return result
}

export const save = (classify: any) => {
  if (classify == null) {
    return
  }
  localStorage.setItem('classify', JSON.stringify(classify))
}

/** 安全读取分类树；脏数据或未加载时返回 { child: [] } */
export const get = () => {
  const raw = localStorage.getItem('classify')
  if (raw == null || raw === '' || raw === 'undefined') {
    return { child: [] }
  }
  try {
    const parsed = JSON.parse(raw) as any
    if (!parsed || typeof parsed !== 'object' || !Array.isArray(parsed.child)) {
      return { child: [] }
    }
    return parsed
  } catch {
    return { child: [] }
  }
}

export const getByParentId = (parentId: number) => {
  const root = get().child
  if (!Array.isArray(root)) {
    return []
  }
  if (parentId == 0) {
    return root
  }
  // 只有两级所以不用再次遍历
  for (let index = 0; index < root.length; index++) {
    const c = root[index]
    if (c.id == parentId) {
      return Array.isArray(c.child) ? c.child : []
    } else if (Array.isArray(c.child)) {
      for (let index3 = 0; index3 < c.child.length; index3++) {
        const c3 = c.child[index3]
        if (c3.id == parentId) {
          return Array.isArray(c3.child) ? c3.child : []
        }
      }
    }
  }

  return []
}

export const getNameById = (id: number) => {
  if (id == 0) {
    return '-'
  }
  const root = get().child
  if (!Array.isArray(root)) {
    return '-'
  }
  for (let index = 0; index < root.length; index++) {
    const c = root[index]
    if (c.id == id) {
      return c.classifyName
    }
    if (!Array.isArray(c.child)) {
      continue
    }
    for (let index2 = 0; index2 < c.child.length; index2++) {
      const cc = c.child[index2]
      if (cc.id == id) {
        return cc.classifyName
      }
      if (!Array.isArray(cc.child)) {
        continue
      }
      for (let index3 = 0; index3 < cc.child.length; index3++) {
        const cc3 = cc.child[index3]
        if (cc3.id == id) {
          return cc3.classifyName
        }
      }
    }
  }

  return '-'
}
